import styled from "styled-components";

import { palette, modularScale } from "@otta/design-tokens";

export const SourcingSideBar = styled.div`
  padding: ${modularScale()};
  background-color: ${palette.brand.white};
  width: 100%;
  max-width: 350px;
  overflow-y: auto;
`;

export const SpinnerWrapper = styled.div`
  padding: ${modularScale(10)} 0;
`;

export const PageContainer = styled.div`
  display: flex;
  overflow-y: scroll;
  height: 100%;
`;

export const CandidatesContainer = styled.div`
  padding: ${modularScale()};
  flex: 1;
  overflow-y: scroll;
`;
